import React, { useEffect, useState } from "react";
import { useUserStore } from "../../../store/userStore.js";
import { useLocation } from "react-router-dom";
import { Empty, Switch } from "antd";


import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";
import UserProfileGalleryBox from "../../../components/userprofilephptos/userprofilegallerybox";

import images from "../../../assets";
import Spacer from "../../../components/spacer/spacer";
import Loader from "../../../components/loader/loader";

const getStatus = (image, imgArr) => {
  const imgObj = imgArr.find((img) => img.originalUrl === image);

  if (imgObj) {
    return imgObj.status;
  } else {
    return null;
  }
};
export default function PhotosGallery() {
  const location = useLocation();
  const { user: userData, isUserLoading: userLoading, getUser, updateUser } =
    useUserStore();

  const username = location.pathname.split("/")[2];

  const [galleryData, setGalleryData] = useState([]);

  useEffect(() => {
    getprofileData();
  }, [username]);

  useEffect(() => {
    setGalleryData(userData?.imageGallery);
  }, [userData]);

  const getprofileData = () => {
    const payload = { username };
    getUser(payload);
  };

  const updateProfile = (newGalleryData) => {
    const updatedGalleryData = newGalleryData?.map(
      ({ signedUrl, ...rest }) => rest
    );
    console.log("in update all photos", updatedGalleryData);
    const payload = { username, data: { imageGallery: updatedGalleryData } };
    updateUser(payload, () => getprofileData());
  };

  return (
    <UserProfileLayout>
      {userLoading ? (
        <Loader />
      ) : (
        <div className="w-full bg-white rounded-2xl border border-primary50 gap-4 flex flex-col p-8">
          <div className="flex-col justify-center items-center gap-3 flex">
            <div className="flex-col justify-center items-center gap-2 flex">
              <div className="justify-center items-center gap-1 flex">
                <div className="text-[#222222]">
                  Keep the photo blurred&nbsp;
                </div>
                <Switch defaultChecked />
              </div>
              <p className="text-[#222222] text-[9px]">
                Blur or reveal your photo. Males can toggle; females are blurred
                by default.
              </p>
            </div>

            {/* <div className="self-stretch h-[180px] p-2.5 bg-white rounded-lg border border-[#222222] flex-col justify-center items-center gap-2.5 flex">
              Upload Btn
            </div> */}
          </div>
          <Spacer height="40px" />
          <div className="w-full flex gap-8">
            {userData?.imageGallery && userData?.imageGallery?.length > 0 ? (
              <div className="w-full justify-start items-start gap-6 flex flex-wrap">
                <div className="w-[270px] p-4 bg-white rounded-2xl shadow border border-primary50 flex-col justify-start items-center gap-6 inline-flex">
                  <h3 className="self-stretch text-center text-basePrimary font-semibold">
                    Profile Photo
                  </h3>
                  <div className="w-[196px] h-[196px] justify-start items-center gap-2.5 inline-flex relative">
                    <div className="w-full min-w-[150px] rounded-full border-2 border-basePrimary">
                      <img
                        className="w-full min-w-[150px] aspect-square object-cover rounded-full"
                        src={userData?.profilePictureSigned}
                        alt="dp"
                      />
                    </div>

                    <div className="justify-center items-center flex w-[34px] h-[34px] right-0 bottom-5 absolute bg-secondary rounded-full">
                      <img src={images.cameraIcon} alt="camera" />
                    </div>
                  </div>
                  <p className="text-center text-[#222222] text-sm">
                    (Supported formats: JPG, PNG. Max size: 5MB)
                  </p>

                  <div className="items-center gap-2 flex">
                    <p>Status:</p>
                    <div className="justify-start items-start flex">
                      <div
                        className={`px-2 py-1 rounded-xl justify-center items-center flex ${
                          getStatus(
                            userData?.profilePicture,
                            userData?.imageGallery
                          ) === "active"
                            ? "bg-green-100"
                            : getStatus(
                                userData?.profilePicture,
                                userData?.imageGallery
                              ) === "pending"
                            ? "bg-yellow-50"
                            : "bg-red-100"
                        }`}
                      >
                        <img
                          src={
                            getStatus(
                              userData?.profilePicture,
                              userData?.imageGallery
                            ) === "active"
                              ? images.approvedIcon
                              : getStatus(
                                  userData?.profilePicture,
                                  userData?.imageGallery
                                ) === "pending"
                              ? images.pendingIcon
                              : images.rejectCrossIcon
                          }
                          alt="status"
                          className="h-5 w-5"
                        />
                        <div className="px-0.5 justify-center items-center flex">
                          <p className="text-[#17c964] text-sm capitalize">
                            {getStatus(
                              userData?.profilePicture,
                              userData?.imageGallery
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {userData?.imageGallery?.map((item, index) => (
                  <UserProfileGalleryBox
                    galleryData={galleryData}
                    updateProfile={updateProfile}
                    key={index}
                    image={item?.signedUrl}
                    imageoriginal={item?.originalUrl}
                    status={item?.status}
                  />
                ))}
              </div>
            ) : (
              <Empty />
            )}
          </div>
        </div>
      )}
    </UserProfileLayout>
  );
}








